import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { LoanApi } from "../../../../../services/Api/types";

interface Props {
	loan: LoanApi;
}

const NewLoanPreviewItemsCard = ({ loan }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<Card className={"mb-3"}>
			<Card.Body>
				<h5>{t("modules.loan.field.devices.title")}</h5>
				<table className={"table table-preview"}>
					<thead>
						<tr>
							<th>{t("lib:common.word.name")}</th>
							<th>{t("modules.loan.field.serial_id.title")}</th>
						</tr>
					</thead>
					<tbody>
						{loan.items.map((item, index) => {
							return (
								<tr key={index}>
									<td>{item.name}</td>
									<td>{item.serial_id}</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</Card.Body>
		</Card>
	);
};

export default NewLoanPreviewItemsCard;
